const ensureArray = (value: any[] | any): any[] => (
  Array.isArray(value) ? value : (value != null ? [ value ] : [])
);

export default ensureArray;
